module.exports = __webpack_public_path__ + "static/media/Decoration_Wedding.b6827093.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/outskirts/themedEvent/decorations/Decoration_Wedding.png
// module id = 1352
// module chunks = 3